export const GET_FAVORITE_REQUEST_INIT = 'GET_FAVORITE_REQUEST_INIT';
export const GET_FAVORITE_REQUEST_SUCCESS = 'GET_FAVORITE_REQUEST_SUCCESS';
export const GET_FAVORITE_REQUEST_ERROR = 'GET_FAVORITE_REQUEST_ERROR';

export const ADD_FAVORITE_REQUEST_INIT = 'ADD_FAVORITE_REQUEST_INIT';
export const ADD_FAVORITE_REQUEST_SUCCESS = 'ADD_FAVORITE_REQUEST_SUCCESS';
export const ADD_FAVORITE_REQUEST_ERROR = 'ADD_FAVORITE_REQUEST_ERROR';

export const DELETE_FAVORITE_REQUEST_INIT = 'DELETE_FAVORITE_REQUEST_INIT';
export const DELETE_FAVORITE_REQUEST_SUCCESS = 'DELETE_FAVORITE_REQUEST_SUCCESS';
export const DELETE_FAVORITE_REQUEST_ERROR = 'DELETE_FAVORITE_REQUEST_ERROR';
